var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNofund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#EE797E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_204_1768",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 48,
    height: 48
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_204_1768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5565 48.5566H54.5565V40.5566H52.0565V46.0566H46.5565V48.5566ZM40.003 45.7501C41.601 45.7501 42.9583 45.1908 44.075 44.0721C45.1916 42.9535 45.75 41.5951 45.75 39.9971C45.75 38.3991 45.1906 37.0418 44.072 35.9251C42.9533 34.8085 41.595 34.2501 39.997 34.2501C38.399 34.2501 37.0416 34.8095 35.925 35.9281C34.8083 37.0468 34.25 38.4051 34.25 40.0031C34.25 41.6011 34.8093 42.9585 35.928 44.0751C37.0466 45.1918 38.405 45.7501 40.003 45.7501ZM25.4435 39.6936H27.9435V34.1936H33.4435V31.6936H25.4435V39.6936ZM19.2935 54.7066V25.2651H60.735V54.7066H19.2935ZM23.2545 50.7456H56.7455V29.2546H23.2545V50.7456Z",
    fill: "#0B0E4A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNofund);
export default __webpack_public_path__ + "static/media/nofund.46f287ec066f3577c653016f55f9628f.svg";
export { ForwardRef as ReactComponent };